import * as z from "zod";

export const getWorkOrderStationV2Enabled = {
  name: "getWorkOrderStationV2Enabled" as const,
  input: z.object({}),
  output: z.object({ enabled: z.boolean() }),
};
